// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import styles from "./aboutPage.module.scss";
import { useLocalizedPath } from "../../i18n/localizedPath";

type FeatureGroup = {
    heading: string;
    items: Array<{ title: string; description: string; path: string }>;
};

function AboutPage() {
    const lp = useLocalizedPath();
    const { t, i18n } = useTranslation("aboutPage");
    const isPt = i18n.language === "pt";
    const currentPath = isPt ? "/pt/about" : "/about";
    const featureGroups = t("features.groups", { returnObjects: true }) as FeatureGroup[];

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main id="main-content" className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>{t("title")}</h1>
                    <p className={styles.description}>{t("description")}</p>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("mission.heading")}</h2>
                        <p className={styles.cardText}>{t("mission.text")}</p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("difference.heading")}</h2>
                        <p className={styles.cardText}>{t("difference.text")}</p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("features.heading")}</h2>
                        <p className={styles.featureIntro}>{t("features.intro")}</p>
                        <div className={styles.featureGroups}>
                            {featureGroups.map((group, index) => (
                                <section key={group.heading} className={styles.featureGroup} aria-labelledby={`about-feature-group-${index}`}>
                                    <h3 id={`about-feature-group-${index}`} className={styles.featureGroupTitle}>{group.heading}</h3>
                                    <ul className={styles.featureList}>
                                        {group.items.map((feature) => (
                                            <li key={feature.path}>
                                                <Link to={lp(feature.path)} className={styles.featureLink}>
                                                    <span className={styles.featureName}>{feature.title}</span>
                                                    <span className={styles.featureDescription}>{feature.description}</span>
                                                    <span className={styles.featureCta} aria-hidden="true">{t("features.featureCta")} <span>→</span></span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </section>
                            ))}
                        </div>
                        <p className={styles.releaseLinkText}>
                            {t("features.releaseLinkPrefix")}{" "}
                            <Link to={lp("/releases")} className={styles.releaseLink}>{t("features.releaseLinkText")}</Link>{" "}
                            {t("features.releaseLinkSuffix")}
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("credits.heading")}</h2>
                        <p className={styles.cardText}>{t("credits.text")}</p>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default AboutPage;
